import React, { useState } from 'react';
import Logo from '../assets/images/logo.svg';

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState('');
  const [openSubMenu, setOpenSubMenu] = useState({
    solutions: false,
    industries: false,
  });

  const solutions = [
    { title: 'Analytics', href: 'https://tailwindcss.com/docs/flex-direction' },
    { title: 'Engagement', href: '#' },
    { title: 'Security', href: '#' },
  ];

  const industries = [
    { title: 'Healthcare', href: '#' },
    { title: 'Finance', href: '#' },
    { title: 'Technology', href: '#' },
  ];

  const toggleSidebar = () => setOpenMenu(openMenu === 'mobile' ? '' : 'mobile');

  const toggleSubMenu = (menu) => {
    setOpenSubMenu((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  return (
    <nav className=" bg-black text-white p-4 bg-opacity-50 backdrop-blur-md shadow-lg border border-gray-700">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img src={Logo} alt="Namunah Logo" className="h-12 w-auto" />
        </div>

        {/* Mobile menu button */}
        <button className="lg:hidden p-2" onClick={toggleSidebar}>
          <svg
            className="w-6 h-6"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>

        {/* Desktop menu */}
        <div className="hidden lg:flex items-center space-x-8">
          <div
            className="relative group"
            onMouseEnter={() => setOpenSubMenu({ ...openSubMenu, solutions: true })}
            onMouseLeave={() => setOpenSubMenu({ ...openSubMenu, solutions: false })}
          >
            <button
              className="py-2 px-3 hover:text-purple-400 transition-colors text-[#D8C8FA] flex items-center"
              onClick={() => toggleSubMenu('solutions')}
            >
              Solutions
              <svg
                className="ml-2 w-4 h-4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSubMenu.solutions && (
              <div className="absolute left-0 mt-2 w-48 bg-black border border-gray-700 rounded-md shadow-lg py-1">
                {solutions.map((item) => (
                  <a
                    key={item.title}
                    href={item.href}
                    className="block px-4 py-2 hover:bg-purple-900 transition-colors text-[#D8C8FA] cursor-pointer"
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            )}
          </div>

          <div
            className="relative group"
            onMouseEnter={() => setOpenSubMenu({ ...openSubMenu, industries: true })}
            onMouseLeave={() => setOpenSubMenu({ ...openSubMenu, industries: false })}
          >
            <button
              className="py-2 px-3 hover:text-purple-400 transition-colors text-[#D8C8FA] flex items-center"
              onClick={() => toggleSubMenu('industries')}
            >
              Industries
              <svg
                className="ml-2 w-4 h-4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSubMenu.industries && (
              <div className="absolute left-0 mt-2 w-48 bg-black border border-gray-700 rounded-md shadow-lg py-1">
                {industries.map((item) => (
                  <a
                    key={item.title}
                    href={item.href}
                    className="block px-4 py-2 hover:bg-purple-900 transition-colors text-[#D8C8FA] cursor-pointer"
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            )}
          </div>
          <a href="#" className="py-2 px-3 hover:text-purple-400 transition-colors text-[#D8C8FA]">
            Blogs
          </a>
          <a href="#" className="py-2 px-3 hover:text-purple-400 transition-colors text-[#D8C8FA]">
            Who Are We?
          </a>
        </div>

        {/* Desktop Get Started Button */}
        <div className="hidden lg:flex relative items-center overflow-hidden rounded-full border-[2px] border-[#210543] p-[2px]">
          <div className="animate-rotate absolute inset-0 h-full w-full rounded-full bg-[conic-gradient(#FFFFFF_20deg,transparent_120deg)]"></div>
          <div className="relative flex w-full rounded-full bg-black px-8 py-3 text-sm text-white">
            Get started
          </div>
        </div>
      </div>
     {/* Mobile Sidebar */}
     {openMenu === 'mobile' && (
        <div className="lg:hidden bg-black text-white py-4 px-6 space-y-4">
          <div >
            <button
              className="py-2 px-3 w-full text-left cursor-pointer flex items-center justify-between hover:text-purple-400 transition-colors text-[#D8C8FA]"
              onClick={() => toggleSubMenu('solutions')}
            >
              Solutions
              <svg
                className=" w-4 h-4 ml-2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSubMenu.solutions && (
              <div className="pl-4">
                {solutions.map((item) => (
                  <a
                    key={item.title}
                    href={item.href}
                    className="flex items-center cursor-pointer space-x-2 px-4 py-2 hover:bg-purple-900 transition-colors text-[#D8C8FA]"
                  >
                  <svg
                    className="w-5 h-5 text-purple-400"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                     <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                    {item.title}
                  </a>
                ))}
              </div>
            )}
          </div>
          <div>
            <button
              className="py-2 px-3 w-full text-left flex cursor-pointer items-center justify-between hover:text-purple-400 transition-colors text-[#D8C8FA]"
              onClick={() => toggleSubMenu('industries')}
            >
              Industries
              <svg
                className=" w-4 h-4"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {openSubMenu.industries && (
              <div className="pl-4">
                {industries.map((item) => (
                  <a
                    key={item.title}
                    href={item.href}
                    className="flex items-center space-x-2  cursor-pointer px-4 py-2 hover:bg-purple-900 transition-colors text-[#D8C8FA]"
                  >
                    <svg
                    className="w-5 h-5 text-purple-400"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                     <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                    {item.title}
                  </a>
                ))}
              </div>
            )}
          </div>
          <a href="#" className="flex items-center space-x-2 py-2 px-3 cursor-pointer hover:text-purple-400 transition-colors text-[#D8C8FA]">
            Blogs
          </a>
          <a href="#" className="flex items-center space-x-2 cursor-pointer py-2 px-3 hover:text-purple-400 transition-colors text-[#D8C8FA] ">
            Who Are We?
          </a>
          <div className="relative flex cursor-pointer items-center overflow-hidden rounded-full border-[2px] border-[#210543] p-[2px] w-fit mt-4">
            <div className="animate-rotate absolute inset-0 h-full w-full rounded-full bg-[conic-gradient(#FFFFFF_20deg,transparent_120deg)]"></div>
            <div className="relative flex w-full rounded-full bg-black px-8 py-3 text-sm text-white">
              Get started
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
